
import { defineComponent, onMounted } from "vue";
import SectionDivisor from "./SectionDivisor.vue";

export default defineComponent({
  components: { SectionDivisor },
  data() {
    let isPaused = true;

    onMounted(() => {
      document.addEventListener("scroll", iframeSettings);
    });

    const iframeSettings = () => {
      const landingPage = document.getElementById(
        "landingPage"
      ) as HTMLDivElement;

      /** View port information */
      const { height } = landingPage.getBoundingClientRect();

      /** Iframe information */
      const iframe = document.querySelector(
        "[data-iframe]"
      ) as HTMLIFrameElement;
      const { y } = iframe.getBoundingClientRect();
      const iframeCenterPosition = y + iframe.offsetHeight / 2;
      const runningArea = !(
        iframeCenterPosition < 0 || iframeCenterPosition > height
      );

      if (!isPaused && !runningArea) {
        isPaused = true;
        pauseVideo(iframe);
      } else if (isPaused && runningArea) {
        playVideo(iframe);
        isPaused = false;
      }
    };

    const playVideo = (iframe: HTMLIFrameElement) => {
      if (iframe && iframe.contentWindow)
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
    };

    const pauseVideo = (iframe: HTMLIFrameElement) => {
      if (iframe && iframe.contentWindow)
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"' + "stopVideo" + '","args":""}',
          "*"
        );
    };

    return {
      missions: [
        {
          title: "Missão",
          description:
            "Simplificar a jornada do cliente com produtos e serviços de qualidade.",
          image: "missao.svg"
        },
        {
          title: "Visão",
          description:
            "Estar entre as cinco maiores empresas do mercado em que atuamos, sempre com o cliente e o colaborador no centro dos nossos negócios.",
          image: "visao.svg"
        },
        {
          title: "Valores",
          description:
            "- Pessoas em 1º lugar;\n" +
            "- Foco no cliente;\n" +
            "- Agilidade;\n" +
            "- Confiança e transparência;\n" +
            "- Compromisso com os resultados;\n" +
            "- Determinação e disciplina.",
          image: "valores.svg"
        }
      ]
    };
  }
});
